import freeList from './whiteList';
import list_1 from './powerList/list_1';
import list_2 from './powerList/list_2';

export const whiteList = freeList;
export const powerList = [...list_1, ...list_2];
